/* eslint-disable no-undef */
import $ from "jquery";

const add2cartrent = () => {
  const init = () => {
    handleChangeField();
    handleClickButton();
  };

  const handleChangeField = () => {
    const el = {
      periode: "#Huurperiode",
    };

    $(document).on("change", el.periode, function () {
      const val = parseFloat($("#Huurperiode").val().split("--")[1]);
      $("#price-wrapper_sale #exactly-price").html(val);
    });
  };

  const handleClickButton = () => {
    const el = {
      form: "#js-form-huur",
      additional_data: "#additional-data",
    };

    if ($(el.form).length === 0) return;

    $(document).on("submit", el.form, function (e) {
      e.preventDefault();
      const productId = $(this).data("product_id");
      const thisEl = $(this);
      const fields = {
        price: parseFloat($("#Huurperiode").val().split("--")[1]),
        rentalPeriode: $("#Huurperiode").val().split("--")[2],
        withDeposit: $("#Borgsom").is(":checked")
          ? parseFloat($("#Borgsom").data("price"))
          : 0,
        withAdministrationCost: $("#Administratiekosten").is(":checked")
          ? parseFloat($("#Administratiekosten").data("price"))
          : 0,
        typeIdentity: $("#select-another-option").val(),
        IDNumber: $("#number-input").val(),
        dateofbirth: $("#geboortedatum").val(),
        iban: $("#iban-input").val(),
        acceptance: $("#acceptance").is(":checked") ? 1 : 0,
      };

      if ($(el.additional_data).length > 0) {
        const additional_value = $(el.additional_data).val().split("|");
        const detail = {
          name: additional_value[0],
          price: additional_value[1],
          label: additional_value[2],
          index: additional_value[3],
        };

        // additional_data.push(detail);

        fields.additional_data = detail;
      }

      if (!$("#acceptance").is(":checked")) return;

      $.ajax({
        type: "POST",
        dataType: "json",
        url: parameters.url_admin_ajax,
        data: {
          action: parameters.add2cartrent.action,
          nonce: parameters.add2cartrent.nonce,
          product_id: productId,
          data: fields,
        },
        beforeSend() {
          thisEl.find('button[type="submit"').attr("disabled", true);
        },
        success() {
          jQuery(document.body).trigger("wc_fragments_refreshed");
          location.href = mi_language.cart_url;
          thisEl[0].reset();
        },
        complete() {
          thisEl.find('button[type="submit"').removeAttr("disabled");
        },
      });
    });
  };

  init();
};

try {
  add2cartrent();
} catch (error) {
  // eslint-disable-next-line no-console
  console.error(error);
}
